export type ForumCategory = 'genel' | 'not_istek' | 'soru';

export const categoryLabels: Record<ForumCategory, string> = {
  genel: 'Genel',
  not_istek: 'Not İsteği',
  soru: 'Soru',
};

export const categoryFilterOptions: Array<{ value: ForumCategory | ''; label: string }> = [
  { value: '', label: 'Tümü' },
  { value: 'genel', label: categoryLabels.genel },
  { value: 'not_istek', label: categoryLabels.not_istek },
  { value: 'soru', label: categoryLabels.soru },
];

export interface ForumThreadRow {
  _id: string;
  title: string;
  content: string;
  category: ForumCategory;
  replyCount: number;
  createdAt: string;
  imageUrls?: string[];
  author?: { name: string; avatar?: string; _id?: string };
}
